<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-file-invoice-dollar"></i>
        파트너 청구서 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">청구</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">청구서 파트너</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">지불 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'paid_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'paid_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'paid_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'paid_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'paid_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'paid_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.paid_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.paid_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              <!-- <b-button inline variant="warning" @click="so.opt['paid_at_ed'] = ''; so.opt['paid_at_sd'] = ''">Clear</b-button> -->
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">환불 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'refund_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'refund_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'refund_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'refund_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'refund_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'refund_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.refund_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.refund_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              <!-- <b-button inline variant="warning" @click="so.opt['paid_at_ed'] = ''; so.opt['paid_at_sd'] = ''">Clear</b-button> -->
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_invoice_id">청구서 아이디</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-input v-model="so.opt['invoice_id']" @keyup.enter="refresh"></b-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_description">설명</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-input v-model="so.opt['description']" @keyup.enter="refresh"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_group">그룹 이름</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!group_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button id="ph_search_group" :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">그룹 선택</b-button>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_group">파트너 이름</label>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="partner_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('partner')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-if="!partner_name" class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button id="ph_search_partner" :variant="partner_name ? 'primary' : 'add'" @click="chainPartner = true">파트너 선택</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">지불 실패</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_failed']" @change="change_failed" >
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">지불 완료</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_paid']" @change="change_done">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">환불</label>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['is_refunded']" @change="change_refunded">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1.3rem"></span>{{model.total_paid.toString().padStart(11, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_info mb-2">지불 : <span style="padding-left: 1.3rem"></span>{{model.paid.toString().padStart(11, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">미지불 : <span style="padding-left: 0.5rem"></span>{{model.not_paid.toString().padStart(11, nbsp) | dollar}}</span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk">
              <option disabled value="">검색</option>
              <option value="partner.username">파트너</option>
              <!-- <option value="description">설명</option> -->
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <!-- Todo -->
          <!-- 해당 버튼은 청구서 자동 생성이 실패했을 경우를 대비하여 만들어진 기능입니다 -->
          <!-- <div class="mb7 mr-2 mt-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4" v-if="enable_new !== false && !partner_id" @click="modal_new = true">
              청구서 & 수납
            </button>
          </div> -->
          <!-- <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
          </div> -->
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-tooltip class="w-100" block target="tooltip-target-1" triggers="hover">
            (?) : 지불 내역
          </b-tooltip>
          <b-table class="table table_add table-striped" id="tooltip-target-1" triggers="hover" striped responsive="sm" ref="_list" show-empty empty-text="not found"
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="apply_date" slot-scope="row">
              <span v-if="row.item.apply_date == 'string'">-</span>
              <span v-else>{{ row.item.apply_date | sdate }}</span>
            </template>
            <template slot="partner" slot-scope="row"> {{row.item.partner ? row.item.partner.username : '-'}}</template>
            <template slot="status" slot-scope="row">
              <b-badge v-if="row.item.is_paid" variant="success">지불</b-badge>
              <b-badge v-else-if="row.item.is_refunded" variant="warning">환불</b-badge>
              <b-badge v-else-if="row.item.is_failed" variant="danger">지불 실패</b-badge>
              <b-badge v-else-if="!row.item.is_paid && !row.item.is_refunded && !row.item.is_failed" variant="secondary">-</b-badge>
            </template>
            <template slot="price" slot-scope="row">
              <span v-if="row.item.is_paid"> {{row.item.total_paid | dollar}}</span>
              <span v-else>{{row.item.total_price - row.item.total_partner_price | dollar}}</span>
              <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge>
            </template>
            <template slot="func" slot-scope="row">
              <!-- <b-btn @click="detail(row.item)" size="sm" class="btn btn-sm btn-insert" tabindex="4">Select</b-btn> -->
              <b-btn :disabled="!row.item.paypal_id" @click="bill(row.item.paypal_id)" size="sm" class="btn btn-sm btn-insert" tabindex="4">PayPal</b-btn>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
      <b-button size="sm" variant="dark" @click="confirm_ticket_invoice = true;" v-if="model.id"> Ticket Invoice </b-button>
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Find then Partner and Select" size="xl" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></partner-List>
    </b-modal>
    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="부분 결제 내역" size="xl"  v-model="confirm_payment_history" @ok="confirm_payment_history = false" ok-only ok-variant="outline-primary" ok-title="확인">
      <!-- {"purchased_at":"2020-07-30T05:20:58.965844Z","action":"partner payment","pg_name":"f1","pg":"credit","price":10.0} -->
      <ul>
        <!-- TODO : 테이블로 예쁘게 해야 함 -->
        <!-- <li v-for="item in payment_history" v-bind:key="item.id" v-bind:class="{ strong: item.hp > 300 }"> -->
        <li v-for="(item, index) in payment_history" v-bind:key="index" v-bind:class="{ strong: item.hp > 300} ">
          <p v-if="item && item.payer">
            <!-- paypal -->
            [결제 날짜:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
            [회사:{{item.payer.email_address}}]
            [작업:{{item.purchase_units[0].description}}]
            [결제 방법:{{item.pg}}]
            [가격:{{item.purchase_units[0].amount.value}}]
            [원화:{{item.purchase_units[0].amount.currency_code}}]
            [국가:{{item.payer.address.country_code}}]
          </p>
          <p v-else>
            <!-- boot_pay or credit -->
            [결제 날짜:{{item.purchased_at | datetime}}]
            [회사:{{item.pg_name}}]
            [작업:{{item.action}}]
            [결제 방법:{{item.pg}}]
            [가격:{{item.price}}]
            [원화:{{'KRW'}}]
            [국가:{{'KR'}}]
            <!-- country_code, currency_code -->
          </p>
        </li>
      </ul>
    </b-modal>
    <!-- new -->
    <b-modal class="modal-dialog modal-dialog-centered" title="청구서 생성 및 수납" size="xl" v-model="modal_new" @ok="new_invoice()" ok-only cancel-variant="primary" hide-footer>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label">청구서 ID</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <b-input class="col-form-label" v-model="invoice.invoice_id" disabled placeholder="system auto generated" @keyup.enter="refresh"></b-input>
        </b-col>
        <b-col class="col-xl-2 col-md-12  d-flex align-self-center">
          <label class="col-form-label" for="Partner_Name">파트너 이름</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <b-form-group>
            <b-form-input class="form-control" @keydown.enter="refresh" type="text" :disabled="true" v-model="partner_name">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <b-form-group>
            <b-button tabindex="4"  block id="ph_search_partner" :variant="partner_name ? 'primary' : 'success'" @click="chainPartner = true">파트너 선택</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Started_at">시작 날짜</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <date-picker v-model="invoice.start_at" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
          <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="invoice.month"> </vue-monthly-picker> -->
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Ended_at">마지막 날짜</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <date-picker v-model="invoice.end_at" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
          <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="invoice.month"> </vue-monthly-picker> -->
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Paid_at">지불 날짜</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <date-picker v-model="invoice.paid_at" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
          <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="invoice.month"> </vue-monthly-picker> -->
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_partner">지불</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <b-input-group prepend="$">
            <b-form-input @keydown.enter="refresh" type="number" :disabled="false" v-model="invoice.amount">
            </b-form-input>
          </b-input-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label for="ph_search_opt_type">* 부가 가치세 포함</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="Include_VAT" id="Include_VAT" v-model="invoice.is_tax" @change="change_failed">
            <div class="checkbox-animate">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">* 세금(%)</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
          <b-input-group prepend="$">
            <b-form-input @keydown.enter="refresh" type="number" :disabled="!invoice.is_tax" v-model="invoice.tax"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <div class="d-flex flex-wrap">
        <div class="title mr-auto">
          사용 중인 서비스 안내
        </div>
      </div>
      <hr>
      <b-row>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Invoice_ID">
            서비스 이름
          </label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Partner_Name">
            파트너 가격
          </label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Partner_Name">
            사용 수량<!-- Usage -->
          </label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="Partner_Name">
            사용량 <!-- Amount -->
          </label>
        </b-col>
        <b-col class="col-xl-2 col-md-12">
        </b-col>
      </b-row>
      <b-row v-for="(service, index) in service_list" :key="index" class="m-4">
        <b-col md="4">
          <v-select :readonly="true" label="service_name" v-model="service.service_name" :options="partner_service"></v-select>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="service.partner_price"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="service.usage"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="service.amount"></b-form-input>
        </b-col>
        <b-col>
          <b-button size="sm" variant="warning" @click="remove_service(index)" block> 삭제 </b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="m-4">
        <b-col md="4">
          <v-select :readonly="false" :disabled="!invoice.partner_id" @input="(x) => this.service = Object.assign({}, this.service, x)" v-if="!model.service_name" label="service_name" v-model="model.service" :options="partner_service"></v-select>
        </b-col>
        <b-col>
          <b-form-input :disabled="!invoice.partner_id" @keydown.enter="refresh" type="number" v-model="service.partner_price" placeholder="select service first"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input :disabled="!invoice.partner_id" @keydown.enter="refresh" type="number" v-model="service.usage" @update="service.amount = Number((Number(service.usage) * Number(service.partner_price)).toFixed(2))"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input :disabled="!invoice.partner_id" @keydown.enter="refresh" type="number" v-model="service.amount"></b-form-input>
        </b-col>
        <b-col>
          <b-button size="sm" class="btn btn-sm btn-addition btn-block" tabindex="4" @click="set_service()" block :disabled="!invoice.partner_id"> 추가 </b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col class="col-xl-12 col-md-12">
          <label class="col-form-label" for="opt_description">설명(관리자만 확인 가능)</label>
          <b-textarea class="form-control" v-model="invoice.description" @keyup.enter="refresh"></b-textarea>
        </b-col>
      </b-row>
      <hr>
      <b-form-group class="float-right ">
        <b-button size="sm" class="btn-add" @click="new_invoice"> 저장 </b-button>
        <!-- <b-button size="sm" variant="warning" @click="reset"> Reset </b-button> -->
        <!-- <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button> -->
      </b-form-group>
    </b-modal>
  </div>
  </template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>